import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { guides } from "@/lib/guides";

const TITLE = "Skincare & Hair Care Guides — Jul's Skin";
const DESC =
  "Practical guides on natural soap, hair oiling and beginner skincare routines from Jul's Skin.";

export const Route = createFileRoute("/guides/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://julsskin.shop/guides" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: "https://julsskin.shop/guides" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "Jul's Skin Guides",
          itemListElement: guides.map((g, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: g.title,
            url: `https://julsskin.shop/guides/${g.slug}`,
          })),
        }),
      },
    ],
  }),
  component: GuidesIndex,
});

function GuidesIndex() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main id="main" className="mx-auto max-w-4xl w-full px-6 py-14 flex-1">
        <p className="eyebrow text-muted-foreground">Guides</p>
        <h1 className="display text-4xl md:text-5xl mt-2">Skincare & hair care guides</h1>
        <p className="mt-4 text-muted-foreground max-w-2xl">{DESC}</p>

        <div className="mt-10 grid gap-4">
          {guides.map((g) => (
            <Link
              key={g.slug}
              to="/guides/$slug"
              params={{ slug: g.slug }}
              className="block rounded-2xl border border-border bg-card/60 p-6 hover:bg-card transition-colors"
            >
              <h2 className="display text-2xl">{g.title}</h2>
              <p className="mt-2 text-sm text-muted-foreground">{g.description}</p>
              <span className="mt-3 inline-block text-sm font-medium text-primary">Read guide ›</span>
            </Link>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
